<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import { kilobytes } from '@/utils/formatter';
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    value: {
      type: Array,
      required: true,
    },
    // Added.by.KWShin.2022.07.08.
    isPcapOs: Boolean,
  },
  data() {
    return {
      shape: 'circle',
      data: {
        value: '',
        type: 'string',
      },
      title: this.$t('dv.title.disk'),
    };
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  methods: {
    /**
     * Modified.by.KWShin.2024.03.12.
     * OS 화면은 인스턴스가 single select 모드로 되어 있었으나,
     * 전체를 한꺼번에 볼 수 있게끔 정책 변경을 하므로써,
     * 단일 인스턴스 선택 시에는 해당 인스턴스 값,
     * 전체 인스턴스 선택 시에는 평균값을 보여주도록 로직을 수정함.
     *
     * 그리드 쪽에서 데이터를 읽을 때 전체 혹은 단일 인스턴스의 데이터를 알아서 읽어줌.
     * 인스턴스 별로 합계를 내고, 이 합계를 합한 후 인스턴스 수로 나눈 평균값을 보여줌.
     */
    /*  
    setData(data) {
      if (data.length) this.data.value = kilobytes(data.reduce((acc, item) => (acc += item.kbSec), 0));
      else this.data.value = '';
    },
    */
    setData(dataList) {
      if (dataList.length > 0) {
        let instCount = 0;
        let total = 0;
        this.descendants.forEach(inst => {
          if (inst.active) {
            instCount++;
            dataList.forEach(datum => {
              if (datum.instId == inst.id) {
                total += datum.kbSec;
              }
            });
          }
        });
        this.data.value = kilobytes(Math.ceil(total / instCount));
      } else this.data.value = '0';
    },
  },
};
</script>
